import cloneDeep from "lodash.clonedeep";
import { contentTags } from "../constants/constants";

export function getPhrasesPerPage(story){
    let phrasesPerPage;
    if(story.tags && story.tags.some(t => [
        contentTags.PICTURE_STORY,
        contentTags.EARLY_READER_UP_AND_DOWN,
        contentTags.EARLY_READER_LETTER_FLIES,
        contentTags.EARLY_READER_CHANGE_ONE_PART,
        contentTags.EARLY_READER_ELKONIN_BOXES,
        contentTags.EARLY_READER_ELKONIN,
      ]
      .includes(t))){
        phrasesPerPage = 1;
    }

    return phrasesPerPage;
  }

export function flattenChildrenAndGrandchildren(activitiesInput){
  let activities = cloneDeep(activitiesInput);
  const flattenedActivities = [];
  // Iterate over the activities and move grandchildren under the top-level parent
  activities.forEach(activity => {
    // If the activity has a parent and no children, it's a grandchild
    if (activity.parentId && !activity.children?.length) {
      activities.forEach(topLevel => {
        if (topLevel.children && topLevel.children.some(child => child.activityId === activity.parentId)) {
          // Add the current activity directly to the top-level parent's children array
          topLevel.children.push(activity);
          // Remove the current activity from the activities array
          activities = activities.filter(act => act.activityId !== activity.activityId);
        }
      });
    }
  });
  return activities
}